import { ElementDetails } from "@/lib/types";
import { RowColumnPropsFields } from "./utils";

export const details = {
  name: "Column",
  description: "A container for other elements",
  category: "Container",
  grid: {},
  ...RowColumnPropsFields("Column"),
} as ElementDetails;
